import React, { useEffect, useState } from 'react'
import StarIcon from '@mui/icons-material/Star';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import StairsIcon from '@mui/icons-material/Stairs';
import Status from '../../Components/Status/Status';
import { Oval } from 'react-loader-spinner';
// import ProgressBar from "@ramonak/react-progress-bar";
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import axios from 'axios';
import { useQuery } from 'react-query';
import { baseUrl, path } from '../../constants';
import { Link } from 'react-router-dom';
import Preview from '../Preview/Preview';
import { api } from '../../api';

export default function Courses() {
    const [courses, setCourses] = useState([])
    const [loading, setLoading] = useState(true)
    const [selectedCourse, setSelectedCourse] = useState(null)
    const [tab, setTab] = useState(0)

    useEffect(() => {
        setLoading(true)
        api.get(path.getCourses + '?type=' + ['pending', 'all'][tab]).then(response => {
            let data = response.data
            if(data.success){
                setCourses(data.courses)
            }
        }).finally(() => setLoading(false))
    }, [tab])
    
  return ( 
  <div className='flex flex-col flex-1 overflow-auto gap-4'>
      <div className='flex items-center gap-4'>
          <button onClick={() => setTab(0)} className={`px-4 py-2 font-bold rounded-md ${tab == 0 ? 'text-white bg-main' : 'text-main bg-white border-[1px] border-main'}`}>
              Pending Courses
          </button>
          <button onClick={() => setTab(1)} className={`px-4 py-2 font-bold rounded-md ${tab == 1 ? 'text-white bg-main' : 'text-main bg-white border-[1px] border-main'}`}>
              All Active Courses
          </button>
      </div>
    {loading ? (
        <div className='flex flex-col items-center gap-3'>
            <p className='text-black text-[15px]'>Loading data...</p>
            <Oval
                visible={true}
                height="30"
                width="30"
                color="#52a4e0"
                secondaryColor="#ffffff"
                ariaLabel="oval-loading"
                wrapperStyle={{}}
                wrapperClass=""
                strokeWidth={3}
                />
        </div>
    ) :(
        <table className='courses rounded-md overflow-hidden'>
            <thead className='bg-black'>
                <tr className='text-white text-left'>
                    <th className='p-2'>Seller</th>
                    <th className='p-2'>Course Title</th>
                    <th className='p-2'>Category</th>
                    <th className='p-2'>Level</th>
                    <th className='p-2'>Languages</th>
                    <th className='p-2'>Price</th>
                    <th className='p-2'>Request Date</th>
                    <th className='p-2 text-center'>Actions</th>
                </tr>
            </thead>
            <tbody>
                {courses?.map(course => ( 
                    <tr>
                        <td className='p-2'>{`${course.instructor?.firstName} ${course.instructor?.lastName}`}</td>
                        <td className='p-2'>{course?.title}</td>
                        <td className='p-2'>{course?.subcategory?.name}</td>
                        <td className='p-2'>{course?.level}</td>
                        <td className='p-2'>{course?.languages?.split(';')?.at(0)}</td>
                        <td className='p-2'><span className='text-[#00ff00] font-bold bg-black px-2 py-1 rounded-md'>{course?.price?.toLocaleString()}</span></td>
                        <td className='p-2'>{course.updatedAt?.split('T')?.at(0)}</td>
                        <td className='p-2 flex gap-2 items-center justify-center'>
                            <button className='text-white px-4 py-2 bg-main text-xs font-bold rounded-md' onClick={() => setSelectedCourse(course)}>Preview</button>
                            <Link to={'/course-sections/' + course.id} className='text-white px-4 py-2 bg-main text-xs font-bold rounded-md'>Sections</Link>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    )}
        {selectedCourse && <Preview selectedCourse={selectedCourse} setSelectedCourse={setSelectedCourse} />}
    </div>
  )
}


// export function CourseCard(course) {
//   return (
//     <div href='/' to={'/course/232323'} className='bg-white flex flex-col p-2 rounded-md gap-2 shadow-lg flex-1 h-[400px] hover:scale-105 transition-all cursor-pointer'>
//         <img className='rounded-md h-1/2 w-full object-cover' src={baseUrl + course.thumbnail} alt='course'/>
//         <p className='text-black text-sm font-bold'>{course.title}</p>
//         <p className='text-[#6a6f73] text-xs'>by {course?.instructor?.user?.firstName + ' ' + course.instructor.user.lastName}</p>
//         <div className='flex items-center gap-1'>
//             <p className='text-black text-xs'>{course.value}</p>
//             <StarIcon style={{color: 'black', fontSize: 12}}>Filled</StarIcon>
//             <p className='text-black text-xs'>Rating: {0}</p>
//         </div>
//         <hr />  
//         <div className='flex justify-between p-2 items-center'>
//             <div className='flex items-center gap-2'>
//                 <PeopleAltIcon style={{color: '#000000', fontSize: 12}}>Filled</PeopleAltIcon>
//                 <p className='text-black text-xs'>{course.enrollmentCount} Enrolled</p>
//             </div>

//             <div className='flex items-center gap-2'>
//                 <StairsIcon style={{color: '#000000', fontSize: 12}}>Filled</StairsIcon>
//                 <p className='text-black text-xs'>{course.level}</p>
//             </div>
//         </div>
//         <div className='flex w-full gap-[7px] p-[7px]'>
//             <Link to={`/course-sections/${course.id}`} className='p-1 flex-1 self-center rounded-sm bg-[#198754] text-[#ffffff] no-underline text-md text-center'>Manage Sections</Link>
//             <button onClick={() => course.setSelectedCourse(course.id)} className='p-1 flex-1 self-center rounded-sm bg-[#198754] text-[#ffffff] no-underline text-md text-center'>Preview</button>
//         </div>
//     </div>
//   )
// }
